import { Alert, Modal } from "antd";
import ReadOnlyDocumentViewer from "../../components/Document/ReadOnlyDocumentViewer";
import { PreviewBody, PreviewStatus } from "./BriefBankStyled";

export default function BriefBankPreviewModal({
  open,
  entry,
  onClose,
  embedded = false,
}) {
  const sourceName = entry?.source_name || entry?.title || "Brief";
  const sourceType = String(sourceName).split(".").pop().toLowerCase();

  const preview = (
    <PreviewBody $embedded={embedded}>
      {entry?.source_document_id ? (
        <ReadOnlyDocumentViewer
          key={entry.source_document_id}
          documentId={entry.source_document_id}
          filename={sourceName}
          fileType={sourceType}
        />
      ) : (
        <PreviewStatus>
          <Alert
            type="error"
            showIcon
            message="Preview unavailable"
            description="This brief has no canonical Word source document."
          />
        </PreviewStatus>
      )}
    </PreviewBody>
  );

  if (embedded) return preview;

  return (
    <Modal
      title={entry?.title || "Brief preview"}
      open={open}
      onCancel={onClose}
      footer={null}
      width="min(1200px, calc(100vw - 48px))"
      styles={{ body: { padding: 0 } }}
      destroyOnHidden
    >
      {preview}
    </Modal>
  );
}
